<template>
  <div>
    <el-row>
      <el-col :span="4" v-if="total > 0">
        <filter-group
          ref="gender"
          :title="'Gender'"
          path="demographics.gender"
          :options="get(filters, 'gender')"
          @change="handleFilterChange"
        />
        <filter-group
          ref="age"
          :title="'Age'"
          path="demographics.age"
          :options="get(filters, 'age')"
          @change="handleFilterChange"
        />
        <filter-group
          ref="race"
          :title="'Race'"
          path="demographics.ethnicity"
          :options="get(filters, 'ethnicity')"
          @change="handleFilterChange"
        />
      </el-col>

      <el-col :span="4">
        <filter-group
          ref="language"
          :title="'Language'"
          :virtualListSize="25"
          :isLong="true"
          path="demographics.language"
          :options="get(filters, 'language')"
          @change="handleFilterChange"
        />

        <filter-group
          ref="location"
          :title="'Location'"
          :isLong="true"
          path="demographics.location"
          :options="get(filters, 'location')"
          @change="handleFilterChange"
        />
      </el-col>

      <el-col :span="4">
        <filter-group
          ref="identifier"
          :title="'Contact Details'"
          :options="get(filters, 'contact')"
          :isLong="true"
          valueKey="id"
          labelKey="title"
          path="identifiers"
          @change="handleFilterChange"
        >
          <template v-slot:default="slotProps">
            <span class="option">{{ slotProps.option.title }}</span>
          </template>
        </filter-group>
      </el-col>

      <el-col :span="4">
        <channels-filter
          ref="channel"
          :title="'Channels used'"
          :options="get(filters, 'channel')"
          :isLong="true"
          valueKey="id"
          path="meta.channel"
          labelKey="handle"
          @change="handleFilterChange"
        >
          <template v-slot:default="slotProps">
            <span class="option">{{ slotProps.option.handle }}</span>
          </template>
        </channels-filter>
      </el-col>

      <el-col :span="8">
        <el-row>
          <el-col :span="24">
            <date-range-filter ref="engaged" :title="'Engaged'" @change="handleFilterChange" />
            <br />
            <filter-group
              ref="show"
              :title="'During the shows'"
              :options="get(filters, 'show')"
              :chunk="(get(filters, 'show') || []).length > 1"
              valueKey="id"
              labelKey="title"
              path="meta.show_id"
              @change="handleFilterChange"
            >
              <template v-slot:default="slotProps">
                <span class="option">{{ slotProps.option.title }}</span>
              </template>
            </filter-group>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SocialIcon from '@/components/common/Icons/SocialIcon';
import FilterGroup from '@/components/profiles/filters/FilterGroup';
import DateRangeFilter from '@/components/profiles/filters/DateRangeFilter';
import ChannelsFilter from '@/components/profiles/filters/ChannelsFilter';

import { get, capitalize } from 'lodash';

export default {
  name: 'DemographicsFilter',
  components: {
    DateRangeFilter,
    FilterGroup,
    SocialIcon,
    ChannelsFilter,
  },
  data: () => ({
    groupRefs: [
      'gender',
      'language',
      'location',
      'age',
      'race',
      'identifier',
      'channel',
      'show',
      'engaged',
    ],
  }),
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    get,
    capitalize,
    apply(filter) {
      this.groupRefs.forEach(group => this.$refs[group].apply(filter));
    },
    reset() {
      this.groupRefs.forEach(group => this.$refs[group].reset());
    },
    handleFilterChange(payload) {
      this.$emit('filter', payload);
    },
  },
};
</script>

<style scoped>
h5 {
  color: #c2c5cc;
}
.option {
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// DemographicsFilter.vue?7f494dc4